export default __webpack_public_path__ + "static/media/8_1.378d4c02.jpg";